









































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { ProductionPrep } from '@/models'
import { Utils } from '@/utils'
import {
  PREP_LIST_PAGE_SIZE,
  PREP_STATE,
  PREP_TASK_STATUS,
  PrepStateView,
  prepProgress,
  prepStateView,
  prepTaskStatusOption,
  removePrepItem,
  savePrepItem,
  showPrepError
} from '@/utils/production-prep'
import UpsertProductionPrepModal from '@/components/modals/UpsertProductionPrepModal.vue'

@Component({
  components: { UpsertProductionPrepModal }
})
export default class ProductionPreps extends Vue {
  private preps: ProductionPrep[] = []
  private loading = false
  private searchFilter = ''
  private PREP_STATE = PREP_STATE
  private IN_PROGRESS = prepTaskStatusOption(PREP_TASK_STATUS.IN_PROGRESS)
  private REQUESTED = prepTaskStatusOption(PREP_TASK_STATUS.REQUESTED)
  private perPage = PREP_LIST_PAGE_SIZE
  private currentPage = 1

  private fields = [
    { key: 'name', label: this.$t('production_prep.fields.name'), sortable: true },
    { key: 'editorialProjectName', label: this.$t('production_prep.fields.editorial_project'), sortable: true },
    { key: 'progress', label: this.$t('production_prep.list.progress'), sortable: false, thStyle: { width: '20%' } },
    { key: 'inProgressTasks', label: this.$t('production_prep.status.IN_PROGRESS'), sortable: true, class: 'text-center' },
    { key: 'requestedTasks', label: this.$t('production_prep.list.requested'), sortable: true, class: 'text-center' },
    { key: 'createdOn', label: this.$t('production_prep.list.created_on'), sortable: true },
    { key: 'actions', label: this.$t('table.actions'), sortable: false, class: 'text-center' }
  ]

  get filteredPreps(): ProductionPrep[] {
    if (!this.searchFilter.trim()) return this.preps
    const filter = Utils.normalizeText(this.searchFilter)
    return this.preps.filter(prep =>
      Utils.normalizeText(prep.name).includes(filter) ||
      Utils.normalizeText(prep.editorialProjectName || '').includes(filter)
    )
  }

  // A new search starts from its first page
  @Watch('searchFilter')
  resetPage() {
    this.currentPage = 1
  }

  progress(prep: ProductionPrep): number {
    return prepProgress(prep)
  }

  stateOf(prep: ProductionPrep): PrepStateView {
    return prepStateView(this, prep.requiredTasks, prep.resolvedRequiredTasks)
  }

  detailRoute(prep: ProductionPrep) {
    return { name: 'ProductionPrepDetail', params: { id: String(prep.id) } }
  }

  async created() {
    await this.loadPreps()
  }

  async loadPreps() {
    try {
      this.loading = true
      this.preps = await ApiClient.getProductionPreps()
    } catch (error) {
      showPrepError(this, error)
    } finally {
      this.loading = false
    }
  }

  openCreateModal() {
    this.$bvModal.show('UpsertProductionPrepModal')
  }

  createPrep(prep: ProductionPrep, done: (saved: boolean) => void) {
    return savePrepItem(this, () => ApiClient.saveProductionPrep(prep), done, created => this.$router.push(this.detailRoute(created)))
  }

  confirmDelete(prep: ProductionPrep) {
    const message = this.$t('production_prep.list.confirm_delete', { name: prep.name }).toString()
    return removePrepItem(this, message, () => ApiClient.deleteProductionPrep(prep.id), this.loadPreps)
  }
}
